import { useRouterContext } from '$contexts/RouteContext/hooks'
import { redirect, ROUTE_NAMES } from '$router/config'
import { useCallback, useEffect } from 'react'

type Props = {
  isDirty?: boolean
}

export const useBack = ({ isDirty }: Props) => {
  const { beforeCallbacks } = useRouterContext()

  const hasPrevious = history.length > 1

  const onBack = useCallback(() => {
    const action = () => {
      if (hasPrevious) {
        history.back()
        return
      }

      redirect(ROUTE_NAMES.APPS, options => ({ ...options, replace: true }))
    }

    const Invalid = beforeCallbacks.current
      .map(callbackFn => callbackFn(action))
      .includes(false)

    if (Invalid) return

    action()
  }, [hasPrevious, beforeCallbacks])

  useEffect(() => {
    const handleKeydown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault()
        event.stopPropagation()

        onBack()
      }
    }

    window.addEventListener('keydown', handleKeydown)

    return () => {
      window.removeEventListener('keydown', handleKeydown)
    }
  }, [isDirty, onBack])

  return {
    hasPrevious,
    onBack
  }
}
